/**
 * @preserve golfbox.ui-validation.js
 */
(function($, window, undefined) {
	if (window.golfbox.ui === undefined)
		window.golfbox.ui = {};

	var document  = window.document,
		navigator = window.navigator,
		location  = window.location,
		golfbox   = window.golfbox,
		_         = golfbox.ui;

    var __formatErrorText = function(err) {

        if(err.errorText.toLowerCase().indexOf('%fieldname%') >= 0)
            return err.errorText.replace(/%fieldname%/ig, '"' + resolveName() +'"').replace(/""/g, '"');
        return err.errorText;

        function resolveName() {
            var target = $(err.clientId);
            var tmp = '';
            
            tmp = $.trim(target.attr('fieldname'));
            if(tmp.length > 0) {
                return tmp;
            }

            tmp = $.trim(target.data('fieldname'));
            if(tmp.length > 0) {
                return tmp;
            }

            tmp = $('label[for="' + target.attr('id') + '"]');
            if(tmp.length > 0) {
                return tmp.first().html();
            }

            tmp = $(err.clientId.replace(/#/g, '#lbl_'));
            if(tmp.length > 0) {
                return tmp.first().html();
            }

            tmp = $(err.clientId.replace(/#/g, '#lbl'));
            if(tmp.length > 0) {
                return tmp.first().html();
            }

            tmp = target.parent('label');
            if(tmp.length > 0) {
                tmp = tmp.first();
                if(tmp.hasClass('wrap')) {
                    tmp = tmp.children('span');
                    if(tmp.length > 0) {
                        return tmp.first().html();
                    }
                }
            }

            return 'fieldname not found';
        }
    }
    /*DEATH TO BAD CODE*/
	/*var __formatErrorText = function(x) {
		var e     = x,
			t     = e.errorText || '',
			fname = 'fieldname not found';

		if (t.toLowerCase().indexOf('%fieldname%') >= 0) {
			if (e.clientId && $(e.clientId).length > 0) {
				var o = $(e.clientId);

				if ($.trim(o.attr('fieldname')).length > 0) {
					fname = $.trim(o.attr('fieldname'));
				} else if ($.trim(o.data('fieldname')).length > 0) {
					fname = $.trim(o.data('fieldname'));
				} else if ($('label[for="' + o.attr('id') + '"]').length > 0) {
					fname = $('label[for="' + o.attr('id') + '"]').html();
				} else if ($(e.clientId.replace(/#/g, '#lbl_')).length > 0) {
					fname = $(e.clientId.replace(/#/g, '#lbl_')).html();
				} else if ($(e.clientId.replace(/#/g, '#lbl')).length > 0) {
					fname = $(e.clientId.replace(/#/g, '#lbl')).html();
				}
			}

			
		}

		return t;
	};*/

	_.validation = function(prop) {
		var funcObj = function(prop, id) {
			this.items      = [];
			this.errors     = [];
			this.renderArea = prop.renderArea || undefined;

			// validate event
			this.fail   = prop.fail   || undefined;
			this.done   = prop.done   || undefined;
			this.always = prop.always || undefined;

			var _isValid = undefined;

			this.add = function(o, pos) {
				this.items.splice(typeof pos === 'number' ? pos : this.items.length, 0, o);
				return o;
			};

			this.reset = function() {
				this.items = this.errors = [];
				_isValid = undefined;
				$.isFunction(prop.reset) && prop.reset.call(this);
			};

			this.isValid = function() {
				return _isValid;
			};

			this.validate = function(fail, done, always) {
				var that = this;

				that.errors = [];
				_isValid = undefined;

				var process = function(o) {
					var e = {
						clientId   : o.clientId,
						isValid    : o.isValid,
						errorText  : o.errorText,
						formatText : undefined
					};

					if (!e.isValid) {
						var i = that.errors.push(e);
						e.formatText = that.getErrorText(i - 1);
					}
				};

				var init = function(i) {
					var o = that.items[i];

					if (o.validate && $.isFunction(o.validate)) {
						o.validate.call(that);

						if (o.isValid === undefined) {
							var interval = setInterval(function() {
								if (o.isValid === undefined)
									return;
								interval = clearInterval(interval);
								process(o);

								if (i + 1 < that.items.length) {
									init(i + 1);
								} else {
									_isValid = that.errors.length == 0 ? true : false;

									(that.errors.length >= 1 && $.isFunction(that.fail)) && that.fail(that.items, that.errors);
									(that.errors.length == 0 && $.isFunction(that.done)) && that.done(that.items, that.errors);
									($.isFunction(that.always)) && that.always(that.items, that.errors);
									(that.errors.length >= 1 && $.isFunction(fail)) && fail(that.items, that.errors);
									(that.errors.length == 0 && $.isFunction(done)) && done(that.items, that.errors);
									($.isFunction(always)) && always(that.items, that.errors);
								}
							}, 100);
						} else {
							process(o);

							if (i + 1 < that.items.length) {
								init(i + 1);
							} else {
								_isValid = that.errors.length == 0 ? true : false;

								(that.errors.length >= 1 && $.isFunction(that.fail)) && that.fail(that.items, that.errors);
								(that.errors.length == 0 && $.isFunction(that.done)) && that.done(that.items, that.errors);
								($.isFunction(that.always)) && that.always(that.items, that.errors);
								(that.errors.length >= 1 && $.isFunction(fail)) && fail(that.items, that.errors);
								(that.errors.length == 0 && $.isFunction(done)) && done(that.items, that.errors);
								($.isFunction(always)) && always(that.items, that.errors);
							}
						}
					}
				};

				if (that.items.length > 0) {
					init(0);
				} else {
					_isValid = true;

					(that.errors.length >= 1 && $.isFunction(that.fail)) && that.fail(that.items, that.errors);
					(that.errors.length == 0 && $.isFunction(that.done)) && that.done(that.items, that.errors);
					($.isFunction(that.always)) && that.always(that.items, that.errors);
					(that.errors.length >= 1 && $.isFunction(fail)) && fail(that.items, that.errors);
					(that.errors.length == 0 && $.isFunction(done)) && done(that.items, that.errors);
					($.isFunction(always)) && always(that.items, that.errors);
				}

				return _isValid;
			};

			this.getErrorText = function(x) {
				return __formatErrorText(typeof x === 'number' ? this.errors[x] : x);
			};

			this.render = function () {
				var that = this;

				if ($.isFunction(prop.render)) {
				    prop.render.call(that);
				    that.renderArea[0].scrollIntoView();
					return;
				}

				var errors = [];

				for (var i = 0; i < that.errors.length; i++) {
					var txt = that.getErrorText(i);
					errors.push(txt);
				}

				alert(errors.join('\n'));
			};
		};

		var id = (prop && prop.id) ? prop.id : golfbox.getUniqNumber();
		var o  = new funcObj(prop || {}, id);
		_['validation' + id] = o;
		return o;
	};

	_.customValidator = function(func) {
		var funcObj = function(func) {
			this.clientId  = undefined;
			this.isValid   = undefined;
			this.errorText = 'customValidator not valid';

			var that = this;

			this.validate = function() {
				/*
				 * NOTE IN THIS METHOD
				 * 'this' keyword is reference to the validation object when calling from (golfbox.ui.validation()).validate()
				 * 'that' keyword is reference to the funcObj object
				 */

				$.isFunction(func) && func.call(that);
				that.formatText = $.isFunction(this.getErrorText) ? undefined : __formatErrorText(that);

				return that.isValid;
			};
		};

		return new funcObj(func);
	};

	_.regExpValidator = function(targetId, errorText, pattern, allowEmpty) {
		var isValidRegExp = function(value) {
			if (pattern instanceof RegExp)
				return pattern.test(value || '');

			var o = (golfbox.ui.regexlib) ? golfbox.ui.regexlib['pack_' + golfbox.page.lcid] : null;

			if (o) return o(pattern).test(value || '');

			alert('Please import golfbox.ui.regexlib, validation failed.');
			return false;
		};

		return _.customValidator(function() {
			var o = $(targetId),
				v = $.trim(o.val());

			this.clientId  = targetId;
			this.isValid   = (allowEmpty && v == '') ? true : isValidRegExp(v);
			this.errorText = errorText || 'regExpValidator not valid';
		});
	};

	_.emailValidator = function(targetId, errorText, allowEmpty) {
		// The Official Standard: RFC 2822
		var pattern = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9]*[\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/;
		return _.regExpValidator(targetId, errorText || 'emailValidator not valid', pattern, allowEmpty);
	};

	_.inRangeValidator = function(targetId, errorText, min, max, allowEmpty) {
		var isInRange = function(value) {
			var i = (value.indexOf(',') > -1 || value.indexOf('.') > -1) ? golfbox.cc.toDecimal(value) : golfbox.cc.toNumeric(value);
			return (i >= min && i <= max);
		};

		return _.customValidator(function() {
			var o = $(targetId),
				v = $.trim(o.val());

			this.clientId  = targetId;
			this.isValid   = (allowEmpty && v == '') ? true : ((!allowEmpty && v == '') ? false : isInRange(v));
			this.errorText = errorText || 'inRangeValidator not valid';
		});
	};

	_.compareValidator = function(targetId1, targetId2, errorText, operator, type) {
		var isCompareValid = function(a, b) {
			var v1, v2;

			switch ((type || '').toLowerCase()) {
				case 'integer':
				case 'number':
					v1 = (a.indexOf(',') > -1 || a.indexOf('.') > -1) ? golfbox.cc.toDecimal(a) : golfbox.cc.toNumeric(a);
					v2 = (b.indexOf(',') > -1 || b.indexOf('.') > -1) ? golfbox.cc.toDecimal(b) : golfbox.cc.toNumeric(b);
					break;

				case 'string':
					v1 = a.toString();
					v2 = b.toString();
					break;

				case 'handicap':
				case 'hcp':
					v1 = golfbox.cc.toHcp(a);
					v2 = golfbox.cc.toHcp(b);
					break;

				case 'date':
					v1 = golfbox.cc.toDate(a);
					v2 = golfbox.cc.toDate(b);
					break;

				default:
					v1 = a.toString();
					v2 = b.toString();
					break;
			}

			switch (operator) {
				case '!=' : return v1 != v2;
				case '<>' : return v1 != v2;
				case '>'  : return v1 > v2;
				case '>=' : return v1 >= v2;
				case '<'  : return v1 < v2;
				case '<=' : return v1 <= v2;
				case '='  : return v1 == v2;
				case '==' : return v1 == v2;
			}

			return v1 == v2;
		};

		return _.customValidator(function() {
			var o1 = $(targetId1),
				o2 = $(targetId2),
				v1 = $.trim(o1.val()),
				v2 = $.trim(o2.val());

			this.isValid   = isCompareValid(v1, v2);
			this.errorText = errorText || 'compareValidator not valid';
		});
	};

	_.dateValidator = function(targetId, errorText, allowEmpty) {
		var padZeros = function(v) {
			if (v < 10)
				return '0' + v;
			return v;
		};

		var isLeapYear = function(val) {
			var n = val;
			if (n < 99)
				n = (n < 20) ? parseInt('20' + padZeros(n)) : parseInt('19' + padZeros(n));
			if (n % 400 == 0)
				return true;
			if (n % 100 == 0)
				return false;
			if (n % 4 == 0)
				return true;
			return false;
		};

		var getDaysInMonth = function(month, year) {
			if (month == 1 || month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12)
				return 31;
			if (month == 4 || month == 6 || month == 9 || month == 11)
				return 30;
			if (month == 2)
				return isLeapYear(year) ? 29 : 28;
			return 0;
		};

		var isDateValid = function(value) {
			var parts       = golfbox.cc.getDateParts(value),
				daysInMonth = getDaysInMonth(parts[1], parts[0]);
			return (parts[2] <= daysInMonth && parts[1] <= 12 && parts[0] <= 2099 && parts[0] >= 1900);
		};

		return _.customValidator(function() {
			var o = $(targetId),
				v = $.trim(o.val());

			if (allowEmpty && v == '') {
				this.isValid = true;
			} else {
				if (!golfbox.ui.regexlib['pack_' + golfbox.page.lcid]('date').test(v)) {
					this.isValid = false;
				} else {
					this.isValid = isDateValid(v);
				}
			}

			this.clientId  = targetId;
			this.errorText = errorText || 'dateValidator not valid';
		});
	};

	_.timeValidator = function(targetId, errorText, allowEmpty) {
		var pattern = /^[0-2][0-9]:[0-5][0-9]$/;
		return _.regExpValidator(targetId, errorText || 'timeValidator not valid', pattern, allowEmpty);
	};

	_.decimalValidator = function(targetId, errorText, intDecimals, allowEmpty) {
		var getPattern = function() {
			if (intDecimals === 1)
				return /^-?\d+((,|\.)\d{1,1})?$/;
			if (intDecimals === 3)
				return /^-?\d+((,|\.)\d{1,3})?$/;
			if (intDecimals === 4)
				return /^-?\d+((,|\.)\d{1,4})?$/;
			return /^-?\d+((,|\.)\d{1,2})?$/;
		};

		return _.regExpValidator(targetId, errorText || 'decimalValidator not valid', getPattern(), (typeof intDecimals === 'boolean' && allowEmpty === undefined) ? intDecimals : allowEmpty);
	};

	_.numberValidator = function(targetId, errorText, min, max, allowEmpty) {
		var isNumberValid = function(value) {
			if (/^-?\d+$/.test(value || '')) {
				var v = (+value),
					a = typeof min === 'number' ? min : undefined,
					b = typeof max === 'number' ? max : undefined;
				if (a !== undefined && b !==  undefined)
					return (v < a || v > b) ? false : true;
				if (a !== undefined)
					return (v < a) ? false : true;
				if (b !== undefined)
					return (v > b) ? false : true;
				return true;
			}
			return false;
		};

		return _.customValidator(function() {
			var o = $(targetId),
				v = $.trim(o.val());

			if (typeof min === 'boolean' && allowEmpty === undefined)
				allowEmpty = min;

			this.clientId  = targetId;
			this.isValid   = (allowEmpty && v == '') ? true : isNumberValid(v);
			this.errorText = errorText || 'numberValidator not valid';
		});
	};

	_.maxlenghtValidator = function(targetId, errorText, max, allowEmpty) {
		var isWithinLimit = function(value) {
			return (value > max) ? false : true;
		};

		return _.customValidator(function() {
			var o = $(targetId),
				v = ($.trim(o.val()) + '').length;

			this.clientId  = targetId;
			this.isValid   = (allowEmpty && v == 0) ? true : (v == 0) ? false : isWithinLimit(v);
			this.errorText = errorText || 'maxlenghtValidator not valid';
		});
	};

	_.requiredValidator = function(targetId, errorText) {
		return _.customValidator(function() {
			var o = $(targetId),
				v = $.trim(o.val());

			this.clientId  = targetId;
			this.isValid   = (v != '');
			this.errorText = errorText || 'requiredValidator not valid';
		});
	};

	_.radioValidator = function(targetName, errorText) {
		return _.customValidator(function() {
			this.isValid   = ($('input[name=\'' + targetName + '\']:checked').length > 0);
			this.errorText = errorText || 'radioValidator not valid';
		});
	};

	_.checkboxValidator = function(targetIds, errorText, min, max) {
		return _.customValidator(function() {
			var o = $.isArray(targetIds) ? $(targetIds.join(',')) : $(targetIds),
				a = (typeof min === 'number') ? min : 1,
				b = (typeof max === 'number') ? max : o.length,
				c = 0;

			o.each(function() {
				c = $(this).prop('checked') ? c + 1 : c;
			});

			this.clientId  = o.length > 1 ? this.clientId : targetIds;
			this.isValid   = (c >= a && c <= b);
			this.errorText = errorText || 'checkboxValidator not valid';
		});
	};

	_.pincodeValidator = function(targetId, errorText, allowEmpty) {
		var pattern = /^\d{4}$/;
		return _.regExpValidator(targetId, errorText || 'pincodeValidator not valid', pattern, allowEmpty);
	};

	_.hcpValidator = function(targetId, errorText, allowEmpty) {
		var isHcpValid = function(value) {
			if (/^(-|\+)?\d{1,3}((,|\.)\d)?$/.test(value || '') == false)
				return false;

			var tmpHcp = golfbox.cc.toHcp(value);
			return (tmpHcp >= -99.9 && tmpHcp <= 999.9);
		};

		return _.customValidator(function() {
			var o = $(targetId),
				v = $.trim(o.val());

			this.clientId  = targetId;
			this.isValid   = (allowEmpty && v == '') ? true : isHcpValid(v);
			this.errorText = errorText || 'hcpValidator not valid';
		});
	};

	_.memberNumberValidator = function(targetId, errorText, allowEmpty) {
		var isMemberNumberValid = function(value) {
			return /^\d{1,4}-\d{1,}$/.test(value || '');
		};

		return _.customValidator(function() {
			var o = $(targetId),
				v = $.trim(o.val());

			this.clientId  = targetId;
			this.isValid   = (allowEmpty && v == '') ? true : isMemberNumberValid(v);
			this.errorText = errorText || 'memberNumberValidator not valid';
		});
	};

	_.golfIdValidator = function(targetId, errorText, allowEmpty) {
		var isGolfIdValid = function(value) {
			return /^\d{6}-\d{3}$/.test(value || '');
		};

		return _.customValidator(function() {
			var o = $(targetId),
				v = $.trim(o.val());

			this.clientId  = targetId;
			this.isValid   = (allowEmpty && v == '') ? true : isGolfIdValid(v);
			this.errorText = errorText || 'golfIdValidator not valid';
		});
	};

	_.golfSePasswordValidator = function(targetId, errorText, allowEmpty) {
		var isGolfSePasswordValid = function(value) {
			/*
			 * Valid format: 4 digits
			 * Valid format: Min. 6 characters, letters a-z, upper and lower case + 0-9.
			 *               Must contain at least two digits, example: aBc03F
			 */

			if (/^\d{4}$/.test(value || ''))
				return true;
			if (/^[A-Za-z0-9]{6,}$/.test(value || '')) {
				var digit = 0;
				for (var i = 0; i < value.length; i++) {
					if (/^\d$/.test(value.substr(i, 1)))
						digit++;
				}
				if (digit >= 2)
					return true;
			}
			return false;
		};

		return _.customValidator(function() {
			var o = $(targetId),
				v = $.trim(o.val());

			this.clientId  = targetId;
			this.isValid   = (allowEmpty && v == '') ? true : isGolfSePasswordValid(v);
			this.errorText = errorText || 'golfSePasswordValidator not valid';
		});
	};

	_.ajaxValidator = function(targetId, errorText, url, type, allowEmpty) {
		return _.customValidator(function() {
			var o = $(targetId),
				v = $.trim(o.val());

			if (allowEmpty && v == '') {
				this.isValid = true;
			} else {
				var that = this;

				if (type === 'json') {
					golfbox.ajax.getJSON(url, v, function(data) {
						that.isValid = (data) ? true : false;
					});
				} else if (type === 'get') {
					golfbox.ajax.get(url, v, function(data) {
						that.isValid = (data) ? true : false;
					});
				} else {
					golfbox.ajax.post(url, v, function(data) {
						that.isValid = (data) ? true : false;
					});
				}
			}

			this.clientId  = targetId;
			this.errorText = errorText || 'ajaxValidator not valid';
		});
	};

})(jQuery, window);